import React, { FunctionComponent } from 'react';
import { useProducts } from '../../hooks/useProducts';
import SettingsAppRoutes from '../Routes/settingsAppRoutes';

const SettingsApp: FunctionComponent = () => {
  // Warm the product catalog cache, mirroring the legacy prefetch at mount.
  useProducts();

  return (
    <>
      <SettingsAppRoutes />
    </>
  );
};

export default SettingsApp;
